import { render, staticRenderFns } from "./metadataForm.vue?vue&type=template&id=15a13cbe&"
import script from "./metadataForm.vue?vue&type=script&lang=js&"
export * from "./metadataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports